import Popup from 'devextreme/ui/popup';

export const VLP_POPUP_VIEWPORT_GUTTER_PX = 12;

export const vlpPopupDefaultOptions = {
    container: 'body',
    dragEnabled: true,
    height: 'auto',
    hideOnOutsideClick: false,
    maxHeight: `calc(100dvh - ${VLP_POPUP_VIEWPORT_GUTTER_PX * 2}px)`,
    maxWidth: `calc(100dvw - ${VLP_POPUP_VIEWPORT_GUTTER_PX * 2}px)`,
    showCloseButton: true,
    showTitle: true,
};

/** Installs the application-wide accessibility and viewport baseline for DevExtreme popups. */
export function installVlpPopupDefaults(): void {
    Popup.defaultOptions({
        options: vlpPopupDefaultOptions,
    });
}
